import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

const AddonsRow = ({ addons, getItem, classes }) => {
    return (
        <Box sx={{ ml: 2 }}>
            <Typography variant="caption" className={classes.AddonsHeader}>
                Addons
            </Typography>
            <Box className={classes.AddonsRow}>
                {addons.map((child) => {
                    const menuItem = getItem ? getItem(child.item_code) : null;
                    return (
                        <Box
                            key={(child.name || "") + (child.identifier || "") + "-addon-chip"}
                            className={classes.AddonItem}
                        >
                            <Box className={classes.ItemButtonInner}>
                                <Box className="left" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                    {menuItem?.cover && (
                                        <Avatar
                                            variant="rounded"
                                            src={menuItem.cover}
                                            alt={child.item_name}
                                            sx={{ width: 28, height: 28 }}
                                        />
                                    )}
                                    <Typography variant="body2" className="name">
                                        {child.item_name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default AddonsRow;


